import { ro } from './ro';

export const t = ro;
export const useTranslations = () => ro;
